import { Component, OnInit } from '@angular/core';
import { ServiceLineGridDetail, ServiceLineGridPreview } from 'src/app/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
type RequestType = 'Subsequent' | 'Initial';
@Component({
    // eslint-disable-next-line @angular-eslint/component-selectorselector: 'my-nexus-duplicate-request-visits-dialog',
    templateUrl: './duplicate-request-visits-dialog.component.html',
    styleUrls: ['./duplicate-request-visits-dialog.component.scss'],
    standalone: false
})
export class DuplicateRequestVisitsDialogComponent implements OnInit {
  selected: 'Yes' | 'No' | null = null;
  requestType: RequestType;
  tenantId: string;
  isExternalUser = false;
  editDetail: ServiceLineGridDetail = {};
  deniedVisitDetails: ServiceLineGridPreview = {};
  dateTimeFaxReceived: string;

  ngOnInit(): void {
    const {
      requestType, tenantId, isExternalUser,
      editDetail, dateTimeFaxReceived,deniedVisitDetails } = this.config.data;
      this.requestType = requestType;
      this.tenantId = tenantId;
      this.isExternalUser = isExternalUser;
      this.editDetail = editDetail;
      this.dateTimeFaxReceived = dateTimeFaxReceived;
      this.deniedVisitDetails = deniedVisitDetails;
  }
 constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
  ) {}
  save(): void {
    this.ref.close(this.editDetail);
  }
  cancel(): void {
    this.ref.close();
  }
  onSelect(option : 'Yes' | 'No'){
    this.selected = option;
  }
}
